export const LEGAL_CONFIG = {
  productName: 'MaiColleges',
  operatorName: '[YOUR FULL LEGAL NAME OR REGISTERED ENTITY]',
  contactEmail: 'support@maicolleges.com',
  mailingAddress: '[YOUR BUSINESS MAILING ADDRESS]',
  governingState: '[YOUR STATE]',
  effectiveDate: 'June 20, 2026',
  termsVersion: '2026-06-20',
  privacyVersion: '2026-06-20',
};

export const hasIncompleteLegalConfig = Object.values(LEGAL_CONFIG).some(
  (value) => typeof value === 'string' && value.startsWith('[')
);
